import { Placeholder } from '../Placeholder/Placeholder';
import React, { type JSX } from 'react';

/**
 * Display a placeholder while fetching the cart contents.
 */
export const CheckoutPlaceholder = (): JSX.Element => {
  return (
    <div className="container p-5">
      <div className="row">
        <div className="col-md-10 col-lg-8 col-md-offset-1 col-lg-offset-2">
          <Placeholder/>
          <Placeholder/>
          <Placeholder/>
        </div>
      </div>
    </div>
  );
};
